import React from "react";
import Modal from "../../ui/Modal";
import Form from "../../ui/Form";
import {
  useCreatePermissionMutation,
  useUpdatePermissionMutation
} from "../../utils/permission.utils";
import { makeSlug } from "../../utils/string.utils";

export default function PermissionAddEdit({ modal, toggle, editItem }) {
  const id = editItem?.id ?? "";

  const { loading, createPermission } = useCreatePermissionMutation(["createPermission"]);

  const { loading: updating, updatePermission } = useUpdatePermissionMutation(["updatePermission"]);

  const fields = [
    {
      label: "Name",
      name: "name",
      type: "text",
      placeholder: "Enter a permission name",
      col: { md: 12 },
      rules: { required: "This is required field!" }
    }
  ];

  const defaultValues = {
    name: editItem?.name ?? ""
  };

  const onSubmit = async (data) => {
    const name = data?.name ?? "";
    const slug = makeSlug(name);

    const values = {
      name,
      slug
    };

    if (!!id) {
      const afterUpdated = await updatePermission({ id, ...values });

      if (afterUpdated?.status === 200) {
        toggle();
      }
      return;
    }

    const afterCreated = await createPermission({ ...values });
    if (afterCreated?.status === 201) {
      toggle();
    }
  };

  const isLoading = loading || updating;

  const title = `${!!id ? "Update" : "Create"} Permission`;

  return (
    <Modal modal={modal} toggle={toggle} title={title}>
      <Form
        fields={fields}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
        submitbtnText={isLoading ? `${!!id ? "Updating..." : "Creating...."}` : title}
        toggle={toggle}
        loading={typeof isLoading === "boolean" ? isLoading : undefined}
      />
    </Modal>
  );
}
